/**
 * Featured listings carousel entry.
 *
 * A [lovasok_featured_listings] shortcode saját maga enqueue-olja
 * (featured.min.js), így a nyitóoldalon sem kell a teljes app bundle.
 * Alpine-függése nincs; lovasokParams a chrome bundle-ből globális.
 *
 * @package Lovasok_Marketplace
 */

import { initFeaturedCarousels } from './components/featured-carousel.js';

initFeaturedCarousels();
